import { Component } from '@angular/core';

@Component({
	templateUrl: './HomeComponent.html'
})
export class HomeComponent {


}
